<template>
  <v-container class="pa-5" fluid>
    <v-row justify="center">
      <v-row class="top-banner pa-5" align="center">
        <v-col cols="4">
          <v-img src="https://hub.swiset.com/wp-content/uploads/2022/06/Hall-of-Fame-by-Swiset.png" max-height="77"
                 position="center center" contain/>
        </v-col>
        <v-col cols="8">
          <h1 class="title">{{ $t('title_HallOfFameIndex') }}</h1>
          <h3 class="invitation">{{ $t('subtitle_HallOfFameIndex') }}</h3>
        </v-col>
      </v-row>
    </v-row>
    <router-view/>
  </v-container>
</template>

<script>
export default {
  name: "HallOfFameIndex"
}
</script>

<style lang="scss" scoped>
@import "src/global";

.top-banner {
  background: rgb(17,17,17);
  background: linear-gradient(153deg, rgba(17,17,17,1) 56%, rgb(255, 247, 95) 100%);
  border-radius: 17px;
  max-width: 70%;

  .title {
    font: 42px 'Avenir' !important;
    font-weight: bold;
    color: white !important;
  }

  .invitation {
    color: white !important;
  }
}

.history-text {
  color: $subtitle-color;
}
</style>

